import { render, staticRenderFns } from "./AddressList.vue?vue&type=template&id=78f4dad6&scoped=true"
import script from "./AddressList.vue?vue&type=script&lang=js"
export * from "./AddressList.vue?vue&type=script&lang=js"
import style0 from "./AddressList.vue?vue&type=style&index=0&id=78f4dad6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f4dad6",
  null
  
)

export default component.exports